export enum StatsTrackerEnums {
    Steps = 'Steps',
    Sleep = 'Get Some Sleep',
    ActiveMinutes = 'Active Minutes'
}
